import React, { useEffect } from "react";
import { makeStyles, Typography } from "@material-ui/core";
import clsx from "clsx";
import PaymentRequestStatusEnum from "../../../models/payment-request-status/PaymentRequestStatusEnum";

interface Props {
  statusId: PaymentRequestStatusEnum;
  statusName: string;
}

const useStyles = makeStyles((theme) => ({
  requestStatusElement: {
    textTransform: "uppercase",
    fontSize: "11px",
    lineHeight: "11px",
    padding: "6px 8px 6px 8px",
    borderRadius: "4px",
    fontWeight: 500,
    boxSizing: "border-box",
  },
  default: {
    color: "black",
    background: "white",
  },
  submitted: {
    color: "#E65100",
    background: "#FFE0B2",
  },
  approved: {
    color: "#006064",
    background: "#B9EBF2",
  },
  rejected: {
    color: "#F70029",
    background: "#FCD7DD",
  },
  sentForPayment: {
    color: "#1A4BAD",
    background: "#C9D7F2",
  },
  returned: {
    color: "#263238",
    background: "#CFD8DC",
  },
  draft: {
    color: "#263238",
    background: "#CFD8DC",
  },
  paid: {
    color: "#19A654",
    background: "#C7F0D8",
  },
}));

export default function PaymentRequestStatusElement({
  statusId,
  statusName,
}: Props) {
  const classes = useStyles({});

  const getStatus = () => {
    let statusClassName = "";
    switch (statusId) {
      case PaymentRequestStatusEnum.Submitted:
        statusClassName = clsx(classes.requestStatusElement, classes.submitted);
        break;
      case PaymentRequestStatusEnum.Approved:
        statusClassName = clsx(classes.requestStatusElement, classes.approved);
        break;
      case PaymentRequestStatusEnum.Rejected:
        statusClassName = clsx(classes.requestStatusElement, classes.rejected);
        break;
      case PaymentRequestStatusEnum.SentForPayment:
        statusClassName = clsx(
          classes.requestStatusElement,
          classes.sentForPayment
        );
        break;
      case PaymentRequestStatusEnum.Returned:
        statusClassName = clsx(classes.requestStatusElement, classes.returned);
        break;
      case PaymentRequestStatusEnum.Draft:
        statusClassName = clsx(classes.requestStatusElement, classes.draft);
        break;
      case PaymentRequestStatusEnum.Paid:
        statusClassName = clsx(classes.requestStatusElement, classes.paid);
        break;
      default:
        statusClassName = clsx(classes.requestStatusElement, classes.default);
    }

    return (
      <Typography component="span" className={statusClassName}>
        {statusName}
      </Typography>
    );
  };

  return getStatus();
}
